import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// Replaces segment membership entirely with the given customer_ids
// (unchecked existing members are removed - see backend setSegmentMembers).
export const setCustomerSegmentMembers = createAsyncThunk("setCustomerSegmentMembers", async ({ id, customer_ids }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`customer-segment/${id}/customers`, { customer_ids });
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const CustomerSegmentMembersSlice = createSlice({
	name: "CustomerSegmentMembersSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCustomerSegmentMembersState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(setCustomerSegmentMembers.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(setCustomerSegmentMembers.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(setCustomerSegmentMembers.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCustomerSegmentMembersState } = CustomerSegmentMembersSlice.actions;

export default CustomerSegmentMembersSlice.reducer;
